import CottonIcon from '@/common/icons/CottonIcon';
import LeadIcon from '@/common/icons/LeadIcon';
import TagUserGreen from '@/common/icons/TagUserGreen';
import TagUserIndigo from '@/common/icons/TagUserIndigo';
import WheatIcon from '@/common/icons/WheatIcon';
import { Button } from '@/components/ui/button';

import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface HeaderDataProps {
  cotton?: number;
  employees?: number;
  wheat?: number;
  fx?: number;
}

interface Props {
  title: string;
  isBack?: boolean;
  headerData?: HeaderDataProps;
  isResponsible?: boolean;
}

export const TeacherStudentHeader: FC<Props> = ({
  title,
  isBack = true,
  headerData,
  isResponsible = true,
}) => {
  const navigate = useNavigate();

  return (
    <div className="py-2.5  flex justify-between items-center">
      <div className="flex items-center gap-5">
        {isBack && (
          <Button
            onClick={() => navigate(-1)}
            variant="outline"
            className="p-[10px] h-[40px]"
          >
            <LeadIcon />
          </Button>
        )}
        <p className="text-[24px] leading-7 text-midnight-default font-semibold">
          {title}
        </p>
      </div>
      {isResponsible && (
        <div className="flex gap-2">
          {headerData?.employees && (
            <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
              <TagUserGreen />

              <div className="flex flex-col items-start justify-between">
                <span className="text-[14px] text-gray-phantom">
                  Mas’ullar soni
                </span>
                <span className="text-[24px] font-bold text-green-green-700">
                  {headerData?.employees}
                </span>
              </div>
            </div>
          )}
          {headerData?.fx && (
            <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
              <TagUserIndigo />

              <div className="flex flex-col items-start justify-between">
                <span className="text-[14px] text-gray-phantom">F/X</span>
                <span className="text-[24px] font-bold text-dark-blue-400">
                  {headerData?.fx}
                </span>
              </div>
            </div>
          )}
          {headerData?.cotton && (
            <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
              <CottonIcon />

              <div className="flex flex-col items-start justify-between">
                <span className="text-[14px] text-gray-phantom">
                  Paxta loyihasi
                </span>
                <span className="text-[24px] font-bold text-dark-blue-300">
                  {headerData?.cotton}
                </span>
              </div>
            </div>
          )}
          {headerData?.wheat && (
            <div className="flex p-[12px] gap-[12px] w-[180px] bg-white rounded-[10px] border border-gray-smoke items-center justify-start">
              <WheatIcon />

              <div className="flex flex-col items-start justify-between">
                <span className="text-[14px] text-gray-phantom">
                  G‘alla loyihasi
                </span>
                <span className="text-[24px] font-bold text-orange-orange-700">
                  {headerData?.wheat}
                </span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
